import React from 'react';
import { Route } from 'react-router-dom';
import { useToasts } from 'react-cooked-bread';


const PublicRoute = ({ component: Component, ...rest }) => {
    const toastFuncs = useToasts();
    return (
        <Route {...rest} render={props => (
            <Component {...props} {...toastFuncs} />
        )} />
    );
};


export default PublicRoute;